import { render, staticRenderFns } from "./HignRegister.vue?vue&type=template&id=6de00604&"
import script from "./HignRegister.vue?vue&type=script&lang=js&"
export * from "./HignRegister.vue?vue&type=script&lang=js&"
import style0 from "./HignRegister.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports